import { all, fork } from "@redux-saga/core/effects";

// sagas
import { authSaga } from "./auth.saga";
import {mainSaga} from "./main.saga";

export function* rootSaga() {
  yield all([fork(authSaga), fork(mainSaga)]);
}
